import { useQuery } from "@tanstack/react-query"

import api from "../../services"

import { JobPostStatus, IJobPostList } from "../../interfaces/job_posts"

import cookiesHelper from "../../helpers/cookies";

const useGetJobPostList = (status: JobPostStatus) => {
    const queryFn = async (): Promise<IJobPostList[]> => {
        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const response = await api.get(`/job-posts/list/${status}`)
        return response.data
    }

    return useQuery({
        queryKey: ['job-posts', status],
        queryFn,
        enabled: !!status
    });
}

export default useGetJobPostList;